// extracted by mini-css-extract-plugin
export default {"prose":"HelpButton_prose__+F2ZP"};